import {takeLatest, put, call} from 'redux-saga/effects';
import apiCall from '../../api';
import {UPDATE_NEW_CYCLE_ERROR, UPDATE_NEW_CYCLE_START, UPDATE_NEW_CYCLE_SUCCESS} from "../../types";

export function* update({payload}) {
    try {
        const url = `/news_cycle/${payload.formData.id}/`;
        const method = 'PUT';
        const headers = {Authorization: 'Bearer ' + payload.token, 'Content-Type':'multipart/form-data'};
        const data = (object) => Object.keys(object).reduce((formData, key) => {
            formData.append(key, object[key]);
            return formData;
        }, new FormData());
        const results = yield call(apiCall, url, method, data(payload.formData), headers);
        yield put({type: UPDATE_NEW_CYCLE_SUCCESS, results: results.data});
        yield put(payload.navigate('/app/content-management/manage-cycle'));
    } catch (error) {
        yield put({type: UPDATE_NEW_CYCLE_ERROR, error});
    }
}

export default function* update_new_cycle() {
    yield takeLatest(UPDATE_NEW_CYCLE_START, update);
}